import React from 'react';
import './App.css';
import Routes from './routes';

export default () => (
	<React.Suspense fallback={<div>Loading...</div>}>
		<Routes />
	</React.Suspense>
);
